import React from "react";
import LookupSettingTable from "./LookupSettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showLookupSetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function LookupSetting() {
  const dispatch = useDispatch();
  const { lookup } = useSelector(responseSetting);

  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);

  React.useEffect(() => {
    dispatch(showLookupSetting());
  }, [dispatch]);
  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>LookupSetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>LookupSetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <LookupSettingTable dataSource={lookup} />
        </div>
      </div>
    </>
  );
}
